import { WithDefaultProps } from 'browser/components/atomic-elements/higher-order-components/with-default-props'

import { Label } from 'browser/components/atomic-elements/atoms/label/label'

export const MobileLabel = WithDefaultProps(Label, {
  className: 'nb3'
})
